import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ChartScatter"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 22.5H3C2.17157 22.5 1.5 21.8284 1.5 21V1.5H3V21H22.5V22.5ZM7.5 18C8.32843 18 9 17.3284 9 16.5C9 15.6716 8.32843 15 7.5 15C6.67157 15 6 15.6716 6 16.5C6 17.3284 6.67157 18 7.5 18ZM10.5 12.75C11.3284 12.75 12 12.0784 12 11.25C12 10.4216 11.3284 9.75 10.5 9.75C9.67157 9.75 9 10.4216 9 11.25C9 12.0784 9.67157 12.75 10.5 12.75ZM16.5 12.75C17.3284 12.75 18 12.0784 18 11.25C18 10.4216 17.3284 9.75 16.5 9.75C15.6716 9.75 15 10.4216 15 11.25C15 12.0784 15.6716 12.75 16.5 12.75ZM19.5 6C20.3284 6 21 5.32843 21 4.5C21 3.67157 20.3284 3 19.5 3C18.6716 3 18 3.67157 18 4.5C18 5.32843 18.6716 6 19.5 6ZM10.5 7.5C11.3284 7.5 12 6.82843 12 6C12 5.17157 11.3284 4.5 10.5 4.5C9.67157 4.5 9 5.17157 9 6C9 6.82843 9.67157 7.5 10.5 7.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ChartScatter.vue"]]);
